import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M2 7h4v10H2V7zm5 12h10V5H7v14zM18 7h4v10h-4V7z"
}), 'ViewCarousel');